export default __webpack_public_path__ + "static/media/starButton.4ec491ee.png";